module.exports = __webpack_public_path__ + "static/chuul-96e8652e648f861f1afc18ba58d288b1.jpeg";